<template>
  <el-dialog title="Search Image" :width="dialogWidth" :visible="visible" :close-on-click-modal="false" @close="visible = false">
    <div class="content">
      <div class="img" :style="'background-image:url('+getImgS3(item.newImage)+')'" @click="selectImg(item)" v-for="item,index in tableData" :key="index">
        <img v-if="item.teethWhitening == 1" :style="'filter: brightness('+(item.brightness/50)+') saturate('+(item.saturate/50)+')  contrast('+(item.contrast/50)+');'" :src="getImgS3(item.imageMask)"/>
      </div>

    </div>
    <div class="showmore" v-if="totalRows != tableData.length"><a @click="loadMore">Show more</a></div>
  </el-dialog>
</template>

<script>
import Vue from 'vue';
import moment from 'moment/moment';
import { postAction,getAction } from '@/network/manage';
export default {
  name: 'CaseHistoryList',
  components: {},
  data() {
    return {
      dialogWidth:'800px',
      visible:false,
      form_loading: false,
      totalRows: 0,
      current_page: 1,
      page_size: 24,
      tableData: [],
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  computed: {

  },
  created() {
    this.setDialogWidth()
  },
  methods: {
    moment,
    getImgS3(key) {
      return process.env.VUE_APP_BASE_XA + '/sys/common/test/getImgS3?key=' + key
    },
    init() {
      this.visible = true
      this.tableData = []
      this.getDatas(1)
    },
    getDatas(initSize) {
      if(initSize == 1) {
        this.current_page = 1
      } else {
        this.current_page = initSize
      }
      this.table_loading = true
      getAction("/admin/caseHistory/list?pageSize=" + this.page_size + "&pageNo=" + this.current_page,{keywords:''}).then((res) => {
        if(res.success){
          this.tableData = [...this.tableData].concat(res.result.records)
          this.totalRows = res.result.total
        }else{
          this.$message.error(res.message);
        }
      }).catch((err) => {

      }).finally((res) => {
        this.table_loading = false
      })
    },
    loadMore(){
      this.getDatas(this.current_page + 1)
    },
    selectImg(item){
      this.visible = false
      this.$emit('ok',item)
    },
    setDialogWidth() {
      var val = document.body.clientWidth
      const def = 800 // default width
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    }
  }
}
</script>

<style scoped>
  .content{display: grid;grid-template-columns:1fr 1fr 1fr 1fr; grid-gap: 10px;}
  .content .img{width: 100%;height: 200px;background-repeat:no-repeat;background-size: cover;background-color: #f7f7f7;border-radius: 4px;background-position: center;cursor: pointer;opacity: 0.9;}
  .content img{width: 100%;height: 200px;object-fit: cover;border-radius: 4px;}
  .content .img:hover{border:2px solid #3ea19d;opacity: 1;}
  .showmore{text-align: center;padding:20px 0;}
  .showmore a{color:#3ea19d;cursor: pointer;}
  @media (max-width: 768px) {
     .form{display: grid;grid-template-columns:1fr;}
     .left{border-right: 0px solid #EDF2F7;padding-right:0;margin-right: 0;}
     .content{grid-template-columns:1fr 1fr 1fr;}
     .content img{height: 150px;}
  }
</style>
